export const addPrivateMessage = (messageObj) =>
	({
		type    : 'ADD_PRIVATE_MESSAGE',
		payload : { messageObj }
	});
export const setIsMessageRead = (id, count) =>
{
	return ({
		type    : 'SET_IS_MESSAGE_READ',
		payload : { id, count }
	});
};
export const addActiveParticipant = (participantObj) =>
	({
		type    : 'ADD_ACTIVE_PARTICIPANT',
		payload : { participantObj }
	});
export const addActiveTab = (tabName) =>
	({
		type    : 'ADD_ACTIVE_TAB',
		payload : { tabName }
	});
export const removePeerChat =(id) =>
	({
		type    : 'REMOVE_CHAT',
		payload : { id }
	});